import React, { ReactNode } from 'react'
import { OverlayTrigger, Tooltip as BTooltip } from 'react-bootstrap'
import styles from './Tooltip.module.sass'

export interface Props {
  label: string | ReactNode
  id: string
  className?: string
  pos?: 'top' | 'right' | 'bottom' | 'left' | 'auto'
  children?: any
}
const Tooltip = (mainProps: Props) => {
  const { label = '', id = '', pos = 'auto', className = '', children = null } = mainProps

  const renderTooltip = (props: any) => (
    <BTooltip id={id} className={`${styles.root} ${className}`} {...props}>
      {label}
    </BTooltip>
  )
  return (
    <OverlayTrigger placement={pos} delay={{ show: 50, hide: 50 }} overlay={renderTooltip}>
      {children}
    </OverlayTrigger>
  )
}
export default Tooltip
